module.exports = __webpack_public_path__ + "img/people.6a1a15de.svg";